// extracted by mini-css-extract-plugin
export default {"ellipsisColumn":"lZ21INVrMjHUT3HvEjwT","contactInfoDetailsRow":"umcr31xCJ9kKsK85sA1t"};